<div class="c-updateTosModal">
  <div class="c-updateTosModal_background">
    <span class="title">{{ 'home.lobby.modals.update-tos.title' | translate | uppercase }}</span>
    <span class="subtitle">{{ 'home.lobby.modals.update-tos.subtitle' | translate }}</span>
    <a
      [href]="'home.lobby.modals.update-tos.terms-link' | translate"
      target="_blank"
      >{{ 'home.lobby.modals.update-tos.terms' | translate }}</a
    >
    <a
      [href]="'home.lobby.modals.update-tos.privacy-link' | translate"
      target="_blank"
      >{{ 'home.lobby.modals.update-tos.privacy' | translate }}</a
    >
  </div>

  <slotcom-button
    class="c-button--pink"
    (click)="closeModal()"
    audioType="functionality">
    {{ 'home.buttons.accept' | translate | uppercase }}
  </slotcom-button>
</div>
